<template>
  <div>
    <div class="table-scroll-container">
      <v-data-table
        :headers="headers"
        :items="results"
        :loading="loading"
        :pagination.sync="pagination"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        class="inline-edit"
        item-key="shipmentId"
        select-all
        v-model="selected"
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td class="fixedTd" style="color: red" v-if="props.item.hasBookingSa">
            {{ props.item.containerNo }}
          </td>
          <td class="fixedTd" v-if="!props.item.hasBookingSa">
            {{ props.item.containerNo }}
          </td>
          <td class="fixedTd">
            {{
              props.item.productCode
                ? props.item.productCode + ':' + props.item.productName
                : ''
            }}
          </td>
          <td class="fixedTd">{{ props.item.skuCode }}</td>
          <td>{{ props.item.needReplace ? '要' : '' }}</td>
          <td>
            {{ props.item.partnerCode + ':' + props.item.partnerName }}
          </td>
          <td>
            {{ props.item.loadingPortCode + ':' + props.item.loadingPortName }}
          </td>
          <td>
            {{
              props.item.dischargePortCode + ':' + props.item.dischargePortName
            }}
          </td>
          <td>{{ props.item.blNo }}</td>
          <td>
            {{ props.item.forwarderCode }} - {{ props.item.forwarderName }}
          </td>
          <td>{{ props.item.doNo }}</td>
          <td>{{ props.item.etd }}</td>
          <td>{{ props.item.eta }}</td>
          <td>{{ props.item.freeDays }}</td>
          <td>{{ props.item.displayStatus }}</td>
          <td>
            {{
              showReserveInfo(props.item) ? props.item.forecastDeliveryDate : ''
            }}
          </td>
          <td>
            {{
              showReserveInfo(props.item)
                ? (props.item.finallyWarehouseCode || '') +
                  ':' +
                  (props.item.finallyWarehouseName || '')
                : ''
            }}
          </td>
          <td>
            <v-btn
              style="max-height: 24px"
              :disabled="deliverySend(props.item)"
              @click="toDetail(props.item.shipmentId)"
              >明細</v-btn
            >
          </td>
        </template>
      </v-data-table>
    </div>
    <div class="table-left-container">
      <v-data-table
        hide-actions
        class="table-left"
        :headers="fixedHeaders"
        :items="results"
        :pagination.sync="pagination"
        :loading="loading"
        :rows-per-page-items="[10]"
        :total-items="pagination.totalItems"
        item-key="shipmentId"
        select-all
        v-model="selected"
        no-data-text
      >
        <template slot="items" slot-scope="props">
          <td>
            <v-checkbox
              hide-details
              primary
              v-model="props.selected"
            ></v-checkbox>
          </td>
          <td class="fixedTd" style="color: red" v-if="props.item.hasBookingSa">
            {{ props.item.containerNo }}
          </td>
          <td class="fixedTd" v-if="!props.item.hasBookingSa">
            {{ props.item.containerNo }}
          </td>
          <td class="fixedTd">
            {{
              props.item.productCode
                ? props.item.productCode + ':' + props.item.productName
                : ''
            }}
          </td>
          <td class="fixedTd">
            {{ props.item.skuCode }}
          </td>
        </template>
      </v-data-table>
    </div>
  </div>
</template>

<script>
export default {
  props: [
    'headers',
    'fixedHeaders',
    'loading',
    'preSelected',
    'multiStatus',
    'query',
  ],
  data() {
    return {
      pagination: {
        page: 0,
      },
      selected: [],
      results: [],
    }
  },
  methods: {
    load(force, query) {
      var actualQuery = query || this.query
      this.$storeParams()
      this.autoload = true
      this.selected = []
      this.$http
        .get('/reserved-shipment', {
          params: {
            status: this.multiStatus.join(','),
            ...actualQuery,
            ...this.$pageable(),
            sort: 'blNo,containerNos',
          },
        })
        .then((res) => {
          this.pagination.page = res.data.number + 1
          this.pagination.rowsPerPage = res.data.size
          this.pagination.totalItems = res.data.totalElements
          this.results = res.data.content

          Promise.all(
            this.results.map((r) => {
              return this.$http
                .get(`/free-days/bl/${r.shipmentId}`)
                .then((res) => {
                  r.freeDays = res.data
                })
            })
          ).then(() => {
            this.preDealData(force)
            this.$forceUpdate()
          })
        })
        .catch(() => {
          this.preDealData(force)
          this.$forceUpdate()
        })
    },
    preDealData(force) {
      if (force) {
        this.selected = [...this.results]
        this.$emit('updateSelected', this.selected)
        this.$emit('exclude')
      }
      if (this.preSelected.length > 0) {
        this.selected = this.preSelected.map((p) => ({
          ...p,
          shipmentId: p.id,
        }))
      }
    },
    showReserveInfo(item) {
      return !(
        item.displayStatus === '例外納入指示申請取消' ||
        item.displayStatus === '例外納入指示拒否' ||
        item.displayStatus === '事前例外納入指示申請取消' ||
        item.displayStatus === '事前例外納入指示拒否'
      )
    },
    deliverySend(shipment) {
      return (
        shipment.status !== '指示Mail送信済' &&
        shipment.status !== 'SJL送信済' &&
        shipment.status !== 'SA一時保存-SJL' &&
        shipment.status !== '事前納入指示Mail送信済'
      )
    },
    toDetail(id) {
      this.$http.get(`/delivery-orders/${id}/booking-count`).then((res) => {
        if (res.data > 0) {
          this.$confirm({
            content: '事前納入指示があります。置き換えますか。',
            rejectAction: 'いいえ',
          })
            .then(() => {
              this.$emit('replace', id)
            })
            .catch(() => {
              this.$router.push({
                name: 'B2300WarehouseDetail',
                query: {
                  id: id,
                },
              })
            })
        } else {
          this.$router.push({
            name: 'B2300WarehouseDetail',
            query: {
              id: id,
            },
          })
        }
      })
    },
  },
  mounted() {},
  watch: {
    selected() {
      this.$emit('updateSelected', this.selected)
    },
    pagination() {
      if (this.autoload) this.load()
    },
  },
}
</script>
